<div class="dialog" role="document" aria-labelledby="media-upload-title">
  <div class="dialog-header">
    <span class="dialog-title" id="media-upload-title">Upload media</span>
    <button type="button" class="close-btn" [disabled]="isLoading" (click)="close()" aria-label="Close">×</button>
  </div>

  <form [formGroup]="form" class="dialog-form" novalidate (ngSubmit)="submit()">
    <div class="field-row">
      <div class="field">
        <label class="field-label" id="media-scope-label">Scope <span aria-hidden="true">*</span></label>
        <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
          <mat-select aria-labelledby="media-scope-label" panelClass="ac-select-panel" [disableOptionCentering]="true" formControlName="scope">
            @if(canPickCentral){ <mat-option value="CENTRAL">Central (shared everywhere)</mat-option> }
            @if(canPickEstablishment){ <mat-option value="ESTABLISHMENT">Establishment</mat-option> }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="field">
        <label class="field-label" id="media-category-label">Category <span aria-hidden="true">*</span></label>
        <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
          <mat-select aria-labelledby="media-category-label" panelClass="ac-select-panel" [disableOptionCentering]="true" formControlName="category">
            @for(c of categories; track c){ <mat-option [value]="c">{{ c | titlecase }}</mat-option> }
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    @if(showEstablishment){
    <div class="field">
      <label class="field-label" id="media-est-label">Establishment <span aria-hidden="true">*</span></label>
      <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
        <mat-select aria-labelledby="media-est-label" panelClass="ac-select-panel" [disableOptionCentering]="true" formControlName="establishmentId" placeholder="Select establishment">
          @for(e of establishments; track e.establishmentId){
          <mat-option [value]="e.establishmentId">{{ e.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    }

    <div class="field">
      <label class="field-label" for="media-file">Image <span aria-hidden="true">*</span></label>
      <input id="media-file" type="file" accept="image/*" class="text-box-active file-input" (change)="onFileSelected($event)" />
      @if(previewUrl){ <img class="preview-img" [src]="previewUrl" alt="Selected image preview" /> }
      <span class="hint">Images only, up to 5 MB.</span>
    </div>

    <div class="field-row">
      <div class="field">
        <label class="field-label" for="media-name">Name <span aria-hidden="true">*</span></label>
        <input id="media-name" type="text" class="text-box-active" maxlength="255" formControlName="name" />
      </div>
      <div class="field">
        <label class="field-label" for="media-remarks">Remarks</label>
        <input id="media-remarks" type="text" class="text-box-active" maxlength="1000" formControlName="remarks" />
      </div>
    </div>

    <div class="dialog-actions">
      <button type="button" class="ac-secondary-btn" (click)="close()">Cancel</button>
      <button type="submit" class="ac-primary-btn" [disabled]="isLoading">Upload</button>
    </div>
  </form>
</div>

<app-loader [isLoading]="isLoading"></app-loader>
